import { useTranslation } from 'react-i18next';

import Reason1 from '@/images/whyPDF/reason1.svg';
import Reason2 from '@/images/whyPDF/reason2.svg';
import Reason3 from '@/images/whyPDF/reason3.svg';
import Reason4 from '@/images/whyPDF/reason4.svg';

function WhyPDFe() {
	const { t } = useTranslation();

	const reasons = t('home.whyPDFe.reasons', { returnObjects: true });
	const reasonImages = [Reason1, Reason2, Reason3, Reason4];

	return (
		<div className="flex w-full flex-col gap-[77px]">
			<div className="flex flex-col items-start gap-3 lg:gap-4">
				<h3 className="font-title text-[32px] font-semibold leading-10 lg:text-[40px] lg:font-bold lg:leading-[52px]">
					{t('home.whyPDFe.title')}
				</h3>
				<h4 className="text-sm font-normal leading-6 lg:text-base lg:leading-7">
					{t('home.whyPDFe.subtitle')}
				</h4>
			</div>
			<div>
				{reasons.map(({ title, subtitle, description }, index) => {
					return (
						<div
							className="flex flex-col-reverse items-start justify-between border-t border-black py-5 lg:flex-row"
							key={index}
						>
							<div className="mt-5 flex flex-col gap-[13px] lg:mt-0 lg:flex-row lg:gap-[124px]">
								<span className="w-full font-semibold leading-7 text-red lg:w-[189px]">
									{title}
								</span>
								<div className="flex w-full flex-col gap-[13px] lg:w-[293px] lg:gap-5">
									<span className="text-sm font-semibold leading-6">
										{subtitle}
									</span>
									<p className="text-xs font-normal leading-5 text-grey-500">
										{description}
									</p>
								</div>
							</div>
							<div className="group flex h-[257px] w-[280px] transform items-center justify-center self-center rounded bg-grey-100 transition duration-500 hover:bg-red focus:bg-red lg:h-[268px] lg:w-[292px]">
								<div className="h-[132px] w-[144px] transform rounded bg-black transition duration-500 group-hover:scale-125 lg:h-[138px] lg:w-[150px]">
									<img
										alt={`reason-${title}`}
										src={reasonImages[index]}
										width="150"
										height="138"
										loading="lazy"
									/>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default WhyPDFe;
